<template>
  <div class="overlay">
    <div>
      <h3>Slack Commands</h3>
      <form class="form-horizontal" v-on:submit.prevent="executeCommand">
        <div class="form-group">
          <select v-model="command" class="form-control">
            <option value="">--Choose a command--</option>
            <option value="donotcontact">Do Not Contact</option>
            <!-- <option value="future">Future</option> -->
            <option value="help">Help</option>
            <option value="redeem">Redeem</option>
            <option value="feedback">Feedback</option>
            <option value="smsapps">SMS Apps</option>
          </select>
        </div>
        <div v-show="command === 'help'" class="form-group">
          <input type="text" class="form-control" v-model="slack" placeholder="Slack name" />
        </div>
        <div v-show="command === 'help'" class="form-group">
          <textarea v-model="comment" class="form-control text" placeholder="Comment"></textarea>
        </div>
        <div class="form-group" v-show="command == 'smsapps'">
          <select v-model="smsapp" class="form-control">
            <option value="">--Choose an app--</option>
            <option v-for="(app, index) in smsapps" :key="index" :value="app.value">{{app.name}}</option>
          </select>
        </div>
        <div class="form-group">
          <button type="submit" class="btn btn-primary" :disabled="command === '' || executing">
            {{executing ? 'Please wait...' : 'Go' }}
          </button>
          <button type="button" class="btn btn-danger" v-on:click="hide()">Cancel</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex';
  import { getUser } from '../../utils/auth';

  export default {
    name: 'Slack',
    props: ['profile'],
    data() {
      return {
        command: '',
        slack: '',
        comment: '',
        executing: false,
        smsapp: ''
      };
    },
    methods: {
      /**
       * @function executeCommand
       * @description executes the slack command from the chatbot app
       */
      async executeCommand() {
        if (this.command) {
          this.executing = true;
          const data = {
            command: this.command,
            phone: this.$route.params.accountid,
            from: getUser().nickname
          };
          let url = 'slack';
          if (this.command === 'redeem') {
            if (!this.profile.referrals.length) {
              this.executing = false;
              return this.$emit('showResponse', 'No referral code', 'error');
            }
            data.code = this.profile.referrals[this.profile.referrals.length - 1].code;
          }
          if (this.command === 'help') {
            data.comment = this.comment;
            data.slack = this.slack;
            url = 'help';
          }
          if (this.command === 'smsapps') {
            url = 'next';
            data.app = this.smsapp;
          }
          try {
            const message = await this.runCommandAction({ url, body: data });
            this.$emit('showResponse', message, 'success');
            this.resetFields(['slack', 'comment', 'command', 'showSlack']);
            this.hide();
          } catch (error) {
            this.$emit('showResponse', error, 'error', false);
          } finally {
            this.executing = false;
          }
        }
        return true;
      },

      /**
       * @function hide
       * @description hide the overlay by emitting an event 'hide'
       */
      hide() {
        this.$emit('hideOverlay');
      },

      /**
       * @function resetFields
       * @description sets form model values to ''
       */
      resetFields(fields) {
        fields.forEach((each) => {
          this[each] = '';
        });
      },
      ...mapActions(['getApps', 'runCommandAction'])
    },
    mounted() {
      this.getApps();
    },
    computed: mapState({
      smsapps: state => state.slack.smsapps
    })
  };
</script>



// WEBPACK FOOTER //
// src/components/chat/Slack.vue